// @flow

import { Button, Icon } from 'semantic-ui-react';
import React from 'react';
import { useSequentialConfirmation } from '@src/custom-hooks/useSequentialConfirmation';

import { StyledButton } from '../../../common-utils/styledComponents';

export const UpdateFormButton = ({
  disabled,
  onClick,
  shouldShowConfirmation = false,
  confirmationConfigs = [],
  onCancel,
}) => {
  const { handleClick, confirmModal } = useSequentialConfirmation({
    onClick,
    onCancel,
    shouldShowConfirmation,
    confirmationConfigs,
  });

  return (
    <>
      <StyledButton
        animated={true}
        circular={true}
        compact={true}
        data-testid="update-form-button"
        disableOnFormErrors={true}
        disabled={disabled}
        onClick={handleClick}
        primary={true}
        size="mini"
      >
        <Button.Content visible={true}>
          <Icon flipped="vertically" name="level down alternate" rotated="clockwise" size="large" />
        </Button.Content>
        <Button.Content hidden={true}>Update</Button.Content>
      </StyledButton>
      {confirmModal}
    </>
  );
};
